import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { baseUrl } from '../Data/service/global.service';
import {
  CheckStatus,
  ChecksReportResponse,
  FetchChecksReportParams,
  UpdateCheckStatusResponse,
} from '../models/checks-report.model';

@Injectable({
  providedIn: 'root',
})
export class ChecksReportService {
  private readonly baseEndpoint = 'invoices-v2/payments/checks';

  constructor(private http: HttpClient) {}

  getChecksReport(params: FetchChecksReportParams): Observable<ChecksReportResponse> {
    let httpParams = new HttpParams();

    Object.entries(params).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') {
        return;
      }
      if (key === 'include_cancelled') {
        httpParams = httpParams.set(key, value ? 'true' : 'false');
        return;
      }
      httpParams = httpParams.set(key, String(value));
    });

    return this.http.get<ChecksReportResponse>(`${baseUrl}${this.baseEndpoint}`, {
      params: httpParams,
    });
  }

  updateCheckStatus(checkId: number, check_status: CheckStatus): Observable<UpdateCheckStatusResponse> {
    return this.http.patch<UpdateCheckStatusResponse>(
      `${baseUrl}${this.baseEndpoint}/${checkId}/status`,
      { check_status },
    );
  }
}
